import Colors from '@/constants/Colors';
import { classicFonts } from '../gameFonts.styled';
import styled from 'styled-components';

export const StyledSortImagesGameActivity = styled.div`
  ${classicFonts}
  width: 100%;
  height: 100%;

  .game-container {
    display: flex;
    flex-direction: column;
    height: 100%;

    .game-activity {
      flex: 1;
      width: 100%;
      border: 1px solid ${Colors.border};
      border-radius: 5px;
      border-bottom-right-radius: 5px;
      overflow-y: auto;
    }
  }

  &.fullscreen {
    .game-activity {
      border: none;
      background-color: ${Colors.backgroundPaleBlue};
      border-radius: 0;
    }
  }
`;
